import { useContent } from '@altify/utils';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import {
  useGetPersonalDataQuery,
  useSaveCountryOfResidenceTaxDataMutation,
} from 'store/slices/personalData-api';
import { taxInformationContent } from '../taxInformation.content';
import {
  Button,
  Heading,
  SelectButtonLikeInput,
  Typography,
} from '@altify/components';
import { useGetCountriesQuery } from 'store/slices/references-api';
import { useState } from 'react';
import CountrySelectionModal from '../components/CountrySelectionModal/CountrySelectionModal';
import { CustomLoader } from 'components/CustomLoader/CustomLoader';

export const Route = createFileRoute('/_authenticated/tax-information/')({
  component: CountryOfResidenceTaxInformation,
});

function CountryOfResidenceTaxInformation() {
  const router = useRouter();
  const {
    data: personalData,
    isLoading: personalDataLoading,
    isFetching: personalDataFetching,
  } = useGetPersonalDataQuery();
  const { data: countries, isLoading: countriesIsLoading } =
    useGetCountriesQuery();
  const [saveCountryOfResidence, saveCountryOfResidenceResult] =
    useSaveCountryOfResidenceTaxDataMutation();
  const [selectedCountry, setSelectedCountry] = useState<string | undefined>(
    personalData?.residencyCountryCode,
  );
  const localizedContent = useContent(taxInformationContent);
  const [showCountrySearch, setShowCountrySearch] = useState(false);
  const handleSubmit = async () => {
    if (selectedCountry) {
      const result = await saveCountryOfResidence(selectedCountry);
      if (!result.error) {
        router.navigate({
          to: '/tax-information/add-home-address',
        });
      }
    }
  };

  const showLoader =
    personalDataLoading || personalDataFetching || countriesIsLoading;

  if (showLoader) {
    return <CustomLoader page />;
  }
  return (
    <div className="w-full items-center">
      <div className="flex flex-col w-full items-center flex-1">
        <div className="flex flex-col items-center mb-10">
          <Heading level={4} className="mb-3 mt-5 text-center">
            {localizedContent.countryOfResidenceTitle}
          </Heading>
        </div>
        <>
          <SelectButtonLikeInput
            label={localizedContent.countryOfResidence}
            placeholder={localizedContent.countryOfResidence}
            value={countries?.find(c => c.code === selectedCountry)?.name}
            onPress={() => setShowCountrySearch(true)}
          />
          <CountrySelectionModal
            isOpen={showCountrySearch}
            handleClose={() => setShowCountrySearch(false)}
            onSelect={setSelectedCountry}
          />
        </>
      </div>
      <div className="w-full pb-2 pt-10 items-center flex flex-col">
        {saveCountryOfResidenceResult.error && (
          <Typography className="my-5 text-center text-error">
            {localizedContent.unexpectedErrorOccurred}
          </Typography>
        )}
        <Button
          size="large"
          color="primary"
          disabled={!selectedCountry}
          onPress={handleSubmit}
          loading={saveCountryOfResidenceResult.isLoading}
          text={localizedContent.continue}
          className="w-full"
        />
      </div>
    </div>
  );
}

export default CountryOfResidenceTaxInformation;
